import { SvgIcon, SvgIconProps } from '@mui/material'
import React from 'react'

const Battery: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox='0 0 24 24'>
      <path
        fill={props?.fill ?? '#1E1E1E'}
        d='M21.75 4.5h-1.5V3.375A.375.375 0 0 0 19.875 3h-3.75a.375.375 0 0 0-.375.375V4.5h-7.5V3.375A.375.375 0 0 0 7.875 3h-3.75a.375.375 0 0 0-.375.375V4.5h-1.5a.375.375 0 0 0-.375.375v15.75c0 .207.168.375.375.375h19.5a.375.375 0 0 0 .375-.375V4.875a.375.375 0 0 0-.375-.375Zm-15 2.599h-.375v.375a.375.375 0 0 1-.75 0v-.375H5.25a.375.375 0 0 1 0-.75h.375v-.375a.375.375 0 0 1 .75 0v.375h.375a.375.375 0 0 1 0 .75Zm7.945 5.971-4.069 5.163a.375.375 0 0 1-.655-.334l.924-3.296-1.314-.066a.376.376 0 0 1-.276-.607l4.069-5.162a.375.375 0 0 1 .655.333l-.924 3.296 1.314.066a.376.376 0 0 1 .276.607ZM18.75 7.1h-1.5a.375.375 0 0 1 0-.75h1.5a.375.375 0 0 1 0 .75Z'
      />
    </SvgIcon>
  )
}

export default Battery
